import { ColDef } from 'ag-grid-community';

const comparator = (a: string, b: string) => {
  if (a == null || b == null) {
    return;
  }
  const aFloat = parseFloat(a);
  const bFloat = parseFloat(b);
  const aIsNumeric = isFinite(aFloat);
  const bIsNumeric = isFinite(bFloat);
  if (!aIsNumeric && bIsNumeric) {
    return 1;
  }
  if (aIsNumeric && !bIsNumeric) {
    return -1;
  }
  if (aIsNumeric && bIsNumeric) {
    return aFloat - bFloat;
  }
  return a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase());
};

export const buildOptionsList = (option: string, rowData: IPackageInfo[]) => {
  return [
    '',
    ...rowData.reduce((list, value) => {
      list.add(value[option]);
      return list;
    }, new Set<string>())
  ];
};

export const buildColumnDefs = (
  rowData: IPackageInfo[],
  { defaultBrightRelease, defaultPackageGroup, defaultArchitecture, defaultDistribution }: IConfig
): ColDef[] => {
  return [
    {
      headerName: 'Cluster manager version',
      showRowGroup: 'cm_version',
      sortable: true,
      cellRenderer: 'agGroupCellRenderer',
      filter: 'agTextColumnFilter',
      floatingFilterComponent: 'selectFloatingFilter',
      floatingFilterComponentParams: {
        options: buildOptionsList('cm_version', rowData),
        suppressFilterButton: true,
        value: defaultBrightRelease
      },
      filterValueGetter: params => (params.data ? params.data.cm_version : null)
    },
    {
      headerName: 'Group',
      showRowGroup: 'group',
      sortable: true,
      cellRenderer: 'agGroupCellRenderer',
      filter: 'agTextColumnFilter',
      floatingFilterComponent: 'selectFloatingFilter',
      floatingFilterComponentParams: {
        options: buildOptionsList('group', rowData).sort(),
        suppressFilterButton: true,
        value: defaultPackageGroup
      },
      filterValueGetter: params => (params.data ? params.data.group : null)
    },
    {
      headerName: 'Architecture',
      showRowGroup: 'arch',
      sortable: true,
      cellRenderer: 'agGroupCellRenderer',
      filter: 'agTextColumnFilter',
      floatingFilterComponent: 'selectFloatingFilter',
      floatingFilterComponentParams: {
        options: buildOptionsList('arch', rowData).sort(),
        suppressFilterButton: true,
        value: defaultArchitecture
      },
      filterValueGetter: params => (params.data ? params.data.arch : null)
    },
    {
      headerName: 'Distribution',
      showRowGroup: 'distro',
      sortable: true,
      cellRenderer: 'agGroupCellRenderer',
      filter: 'agTextColumnFilter',
      floatingFilterComponent: 'selectFloatingFilter',
      floatingFilterComponentParams: {
        options: buildOptionsList('distro', rowData).sort(),
        suppressFilterButton: true,
        value: defaultDistribution
      },
      filterValueGetter: params => (params.data ? params.data.distro : null)
    },
    {
      headerName: 'Version',
      field: 'cm_version',
      hide: true,
      rowGroup: true
    },
    {
      headerName: 'Group',
      field: 'group',
      hide: true,
      rowGroup: true
    },
    {
      headerName: 'Arch',
      field: 'arch',
      hide: true,
      rowGroup: true
    },
    {
      headerName: 'Distro',
      field: 'distro',
      hide: true,
      rowGroup: true
    },
    {
      comparator,
      headerName: 'Package name',
      sortable: true,
      filter: 'agTextColumnFilter',
      field: 'pkg_name'
    },
    {
      comparator,
      headerName: 'Package version',
      sortable: true,
      filter: 'agTextColumnFilter',
      field: 'pkg_version'
    },
    {
      comparator,
      headerName: 'Package release',
      sortable: true,
      filter: 'agTextColumnFilter',
      field: 'pkg_release'
    }
  ];
};

export const mapData = (results: Array<string>): IPackageInfo[] => {
  return results.map(item => {
    const splitted = item.split(',');
    return {
      cm_version: splitted[0],
      numeric_version: Number(splitted[0]),
      group: splitted[1],
      arch: splitted[2],
      distro: splitted[3],
      pkg_name: splitted[4],
      pkg_version: splitted[5],
      pkg_release: splitted[6]
    };
  }).sort((p1, p2) => p2.numeric_version - p1.numeric_version);
};
